// ----------------------------------------------------------------------------
// Snippet: Country Switcher
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

// Styles
import './_country-switcher.scss';


// -------------------------------------
// Variables
// -------------------------------------

// Country Switcher
var COUNTRY_TOGGLE = '.country-switcher__toggle';
var COUNTRY_LIST   = '.country-switcher__list';
var COUNTRY_LINK   = '.country-switcher__link';


// -------------------------------------
// Hooks
// -------------------------------------

$(document).ready(function(){

    // If you click anywhere outside of the search, close it
    $('body').on('click', function(event) {
        if (!$(event.target).closest(COUNTRY_TOGGLE).length) {
            $(COUNTRY_TOGGLE).removeClass('is-open');
            $(COUNTRY_LIST).removeClass('is-open');
        }
    });

    $('.menu__item--country-switcher').on('keyup', function(e) {
        // Listens for Escape Key
        if (e.key == 'Escape' ) {
            $(COUNTRY_TOGGLE).removeClass('is-open');
            $(COUNTRY_LIST).removeClass('is-open');
            $(COUNTRY_TOGGLE).trigger('focus');
        }
    });

    $(COUNTRY_LINK).last().on('blur', function(e) {
        // Listens for Escape Key
        $(COUNTRY_TOGGLE).removeClass('is-open');
        $(COUNTRY_LIST).removeClass('is-open');
    });


    // When you click the search icon, toggle the open state
    $(COUNTRY_TOGGLE).on('click', function(event) {
        // don't fire if we are opening the switcher by clicking on the active link.
        event.preventDefault();
        $(this).toggleClass('is-open');
        $(this).siblings(COUNTRY_LIST).toggleClass('is-open');
    });
});
